import * as React from 'react';
import styled from 'react-emotion';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import history from "../../utils/history";
import {createAPIKey, deleteAPIKey, editAPIKey, getAPIKeys} from "../../utils/auth";
import "bulma/css/bulma.css";
import {Button, Icon} from "bloomer";
import AddEditForm from "./AddEditForm";
import APIKey from "./APIKey";
import Spacer from "../../elements/Spacer";
import DeleteConfirmation from "./DeleteConfirmation";

const Container = styled("div")`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 20px minmax(80vh, auto) minmax(19vh, auto);
  min-height: 100vh;

  @media (max-width: 1024px) {
    grid-template-rows: 20px auto;
  }
`;

const ContentOuter = styled("div")`
  margin-top: 70px;
  grid-column: 3/11;
  @media (max-width: 1024px) {
    grid-column: 2/12;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    grid-column: 1/-1;
  }
`;

const Content = styled("div")`
  margin: 0 20px;
  grid-column: 3/11;
  @media (max-width: 1024px) {
    grid-column: 2/12;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    grid-column: 1/-1;
  }
`;

const Heading = styled("span")`
  font-size: 24px;
  margin-left: 0px;
  margin-top: 30px;
`;

const BackButtonContainer = styled("div")`
    text-align: left;
    color: #2f3241;
    margin-bottom: 20px;
    margin-left: 10px;
    width: 100%;
`;

interface IAPIKeysProps {
    onUpdateUserContext: any;
    openContactForm: any;
}

interface IAPIKeysState {
    windowLoading: boolean;
    loading: boolean;
    data: any;
    showAddForm: boolean;
    showEditForm: boolean;
    showDeleteConfirmation: boolean;
    deletingApiKey: any;
    editingApiKey: any;
    errorMessage: string;
}

class APIKeys extends React.Component<IAPIKeysProps, IAPIKeysState> {

    public constructor(props: IAPIKeysProps) {
        super(props);

        this.state = {
            windowLoading: false,
            loading: false,
            data: [],
            showAddForm: false,
            showEditForm: false,
            showDeleteConfirmation: false,
            deletingApiKey: null,
            editingApiKey: null,
            errorMessage: ""
        };
    }

    public componentDidMount() {
        this.loadData();
    }

    public loadData = async () => {
        const responseData = await getAPIKeys();
        if (responseData) {
            this.setState({
                data: responseData
            });
        }
    };

    public processErrorMessage = (errorData: any) => {
        if (errorData && errorData.message) {
            this.setState({
                errorMessage: errorData.message
            });
        }
    };

    public createAPIKey = async (name: string) => {
        this.setState({
            windowLoading: true,
            errorMessage: ""
        });
        let errorOccurred = false;
        await createAPIKey(name).catch((error) => {
            if (error && error.response && error.response.data) {
                this.processErrorMessage(error.response.data);
            }
            this.setState({
                windowLoading: false
            });
            errorOccurred = true;
        });

        if (!errorOccurred) {
            this.setState({
                showAddForm: false,
                data: []
            }, () => {
                this.loadData();
            });
        }
    };

    public editAPIKey = async (id: number, name: string) => {
        this.setState({
            windowLoading: true,
            errorMessage: ""
        });
        let errorOccurred = false;
        await editAPIKey(id, name).catch((error) => {
            if (error && error.response && error.response.data) {
                this.processErrorMessage(error.response.data);
            }
            this.setState({
                windowLoading: false
            });
            errorOccurred = true;
        });

        if (!errorOccurred) {
            this.setState({
                showEditForm: false,
                editingApiKey: null,
                data: []
            }, () => {
                this.loadData();
            });
        }
    };

    public deleteAPIKey = async (id: number) => {
        this.setState({
            windowLoading: true,
            errorMessage: ""
        });
        let errorOccurred = false;
        await deleteAPIKey(id).catch((error) => {
            if (error && error.response && error.response.data) {
                this.processErrorMessage(error.response.data);
            }
            this.setState({
                windowLoading: false
            });
            errorOccurred = true;
        });

        if (!errorOccurred) {
            this.setState({
                showDeleteConfirmation: false,
                deletingApiKey: null,
                data: []
            }, () => {
                this.loadData();
            });
        }
    };

    public render() {
        return <Container>
            <Header history={history}/>
            <ContentOuter>
                <BackButtonContainer>
                    <Button
                        style={{
                            border: 0,
                            color: "#1c2541"
                        }}
                        title="Go To Dashboard"
                        onClick={(e: any) => {
                            e.target.blur();
                            history.push("/models");
                        }}
                    >
                        <Icon className="fas fa-arrow-left" style={{marginRight: "5px"}}/>Go Back
                    </Button>
                </BackButtonContainer>
                <Content>
                    <Heading>API Keys</Heading>
                    <hr/>
                    <Spacer/>
                    <div style={{textAlign: 'right'}}>
                        <Button
                            onClick={() => {
                                this.setState({
                                    showAddForm: true,
                                    errorMessage: "",
                                    windowLoading: false
                                });
                            }}
                        >Create New API Key</Button>
                    </div>
                    <Spacer/>
                    <hr/>
                    <div>
                        {
                            this.state.data.map((apiKey: any) => {
                                return <APIKey
                                    key={apiKey.id}
                                    data={apiKey}
                                    onEdit={() => {
                                        this.setState({
                                            editingApiKey: apiKey,
                                            showEditForm: true,
                                            errorMessage: "",
                                            windowLoading: false
                                        });
                                    }}
                                    onDelete={() => {
                                        this.setState({
                                            deletingApiKey: apiKey,
                                            showDeleteConfirmation: true,
                                            errorMessage: "",
                                            windowLoading: false
                                        });
                                    }}
                                />;
                            })
                        }
                    </div>
                </Content>
            </ContentOuter>
            {
                this.state.showAddForm ? <AddEditForm
                    loading={this.state.windowLoading}
                    errorMessage={this.state.errorMessage}
                    onSave={(name: string) => {
                        this.createAPIKey(name);
                    }}
                    onClose={() => {
                        this.setState({
                            showAddForm: false,
                            errorMessage: "",
                            windowLoading: false
                        });
                    }}
                /> : <></>
            }
            {
                this.state.showEditForm && this.state.editingApiKey ? <AddEditForm
                    loading={this.state.windowLoading}
                    errorMessage={this.state.errorMessage}
                    editing={true}
                    id={this.state.editingApiKey.id}
                    name={this.state.editingApiKey.name}
                    onSave={(id: number, name: string) => {
                        this.editAPIKey(id, name);
                    }}
                    onClose={() => {
                        this.setState({
                            showEditForm: false,
                            errorMessage: "",
                            windowLoading: false
                        });
                    }}
                /> : <></>
            }
            {
                this.state.showDeleteConfirmation && this.state.deletingApiKey ? <DeleteConfirmation
                    loading={this.state.windowLoading}
                    errorMessage={this.state.errorMessage}
                    id={this.state.deletingApiKey.id}
                    name={this.state.deletingApiKey.name}
                    onDelete={(id: number)=>{
                        this.deleteAPIKey(id);
                    }}
                    onCancel={()=>{
                        this.setState({
                            showDeleteConfirmation: false,
                            deletingApiKey: null
                        })
                    }}
                />  : <></>
            }
            <Footer openContactForm={this.props.openContactForm}/>
        </Container>;
    }
}

export default APIKeys;


// WEBPACK FOOTER //
// ./src/routes/APIKeys/index.tsx